import React from 'react'
import Text from '../Text'

const ContactSection = ({ data }) => {
  const title = data?.title
  const description = data?.description
  const contactBanner = data?.contactBanner
  const emailBanner = data?.emailBanner
  const image1 = data?.image1
  const image2 = data?.image2

  return (
    <section className="bg-white mb-14 overflow-hidden">
      <div className="px-4 bg-white">
        <div className="space-y-2">
          {title ? (
            <Text
              tag="p"
              variant="headline"
              size="small"
              className="text-text-primary"
            >
              {title}
            </Text>
          ) : null}
          {description ? (
            <Text
              tag="p"
              variant="body"
              size="medium"
              className="text-[#667085]"
            >
              {description}
            </Text>
          ) : null}
        </div>

        <div className="flex flex-col gap-1 mb-4 mt-2">
          {contactBanner ? (
            <div className="flex items-center gap-2 px-2 py-1 rounded-lg w-fit">
              {contactBanner?.icon ? (
                <img
                  src={contactBanner?.icon}
                  alt="Phone"
                  className="h-5 w-5 inline-block"
                />
              ) : null}
              <Text
                variant="body"
                size="large"
                className="!text-[18px] whitespace-nowrap text-ellipsis"
                style={{
                  color: contactBanner?.textColor,
                }}
                dangerouslySetInnerHTML={{ __html: contactBanner?.displayText }}
              />
            </div>
          ) : null}

          {emailBanner ? (
            <div className="flex items-center gap-2 px-2 py-1 rounded-lg w-fit">
              {emailBanner?.icon ? (
                <img
                  src={emailBanner?.icon}
                  alt="Phone"
                  className="h-5 w-5 inline-block"
                />
              ) : null}
              <Text
                variant="body"
                size="large"
                className="!text-[18px] whitespace-nowrap text-ellipsis"
                style={{
                  color: contactBanner?.textColor,
                }}
                dangerouslySetInnerHTML={{ __html: emailBanner?.displayText }}
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className="mt-5 flex-col relative h-64">
        {image1 ? (
          <div className="relative flex">
            <div>
              <img
                src={image1}
                alt="Support 1"
                className="!m-0 w-48 h-48 rounded-r-2xl object-cover absolute -left-2 !p-0"
              />
            </div>
          </div>
        ) : null}
        {image2 ? (
          <img
            src={image2}
            alt="Support 2"
            className="w-48 h-48 rounded-l-2xl object-cover absolute -right-2 top-20 !m-0 !p-0"
          />
        ) : null}
      </div>
    </section>
  )
}

export default ContactSection
